import React, { ChangeEvent, useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { getValue } from "@utils/lodash";
import qs from "query-string";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteModal from "@_common/deleteModal";
import moment from "moment";
import "./comments-modal.scss";
import {
  addTaskComments,
  deleteTaskComments,
  getTaskComments,
  updateTaskComments,
} from "@services/comments.service";
import InputField from "@_common/InputRuleFeild";
import { commentsTitleList, commentsValueList } from "@_common/comments";
import { sanitizeInput } from "@_common/dompurify";

interface ICommentsModalProps {
  isOpen: boolean;
  handleModal: () => void;
  vendorInfo: object;
  edit: boolean;
}

const CommentsModal: React.FunctionComponent<ICommentsModalProps> = (
  props: any
) => {
  const navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [userId, setUserId] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [allComments, setAllComments] = useState([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    getData();
    let user = getValue(localStorage, `user`, "");
    let info = JSON.parse(user);
    setUserId(getValue(info, `id`, ""));
  }, [props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    try {
      let payload: any = {
        limit: limit,
        page_no: page_no,
        type: "STANDARD_COMMENT",
        vendor_checkpoint_id: getValue(props, `vendorInfo.id`, ""),
        // domain_name: getValue(localStorage,`client`,''),
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      setLoading(true);
      let resp = await getTaskComments(queryRequest);
      if (resp) {
        setLoading(false);
        setAllComments(getValue(resp, `data.comments`, []));
        setEdit(false);
        setEditId("");
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getDataRefetch = async () => {
    try {
      let payload: any = {
        limit: limit,
        page_no: page_no,
        type: "STANDARD_COMMENT",
        vendor_checkpoint_id: getValue(props, `vendorInfo.id`, ""),
      };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      let resp = await getTaskComments(queryRequest);
      if (resp) {
        setLoading(false);
        setAllComments(getValue(resp, `data.comments`, []));
        setEdit(false);
        setEditId("");
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (editId) {
      try {
        setIsLoading(true);
        let payload = {
          comments: comments,
          type: "STANDARD_COMMENT",
          vendor_checkpoint_id: getValue(props, `vendorInfo.id`, ""),
          // domain_name: getValue(localStorage,`client`,''),
        };
        let resp = await updateTaskComments(editId, payload);
        if (resp) {
          setIsLoading(false);
          toast.success("Updated successfully");
          setComments("");
          getDataRefetch();
          setEdit(false);
          setEditId("");
          setSelectedCommentLabel("");
          setSelectedCommentValue("");
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    } else {
      try {
        setIsLoading(true);
        let payload = {
          comments: comments,
          type: "STANDARD_COMMENT",
          vendor_checkpoint_id: getValue(props, `vendorInfo.id`, ""),
          // domain_name: getValue(localStorage,`client`,''),
        };
        let resp = await addTaskComments(payload);
        if (resp) {
          setIsLoading(false);
          toast.success("Updated successfully");
          setComments("");
          setSelectedCommentLabel("");
          setSelectedCommentValue("");
          getData();
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const handleEdit = (obj: object) => {
    // setSelectedCommentLabel(
    // 	getValue(obj, `comments`, "").split("-")[0].trim(" ")
    // );
    // setSelectedCommentValue(
    // 	getValue(obj, `comments`, "").split("-")[1].trim(" ")
    // );
    setEditId(getValue(obj, `id`, ""));
    setComments(getValue(obj, `comments`, ""));
    setEdit(!edit);
  };
  const handleRemoveSelected = () => {
    setComments("");
    setEditId("");
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.page_no = page_no;
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await deleteTaskComments(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  const [selectedCommentLabel, setSelectedCommentLabel] = useState<any>("");
  const [selectedCommentValue, setSelectedCommentValue] = useState<any>("");
  const handleChangeComments = (type: string, value: string) => {
    if (type === "label") {
      setSelectedCommentLabel(value);
      setComments(`${value} - ${selectedCommentValue}`);
    } else {
      setSelectedCommentValue(value);
      setComments(`${selectedCommentLabel} - ${value}`);
    }
  };
  return (
    <div className="comments-popup">
      <Modal
        isOpen={getValue(props, `isOpen`, "")}
        toggle={getValue(props, `isOpen`, "")}
        centered
        size="lg"
      >
        \
        <div className="comments-modal">
          <div className="comments-popup__header d-flex align-items-center justify-content-between mb-3">
            <h3 className="comments-popup__header-title">Comments</h3>
            <div className="d-flex justify-content-end">
              <img
                src="/images/close-red.svg"
                className="cursor-pointer"
                width={25}
                onClick={props.handleModal}
              />
            </div>
          </div>
          <div>
            <div>
              <h6 className="comments-popup__vendor-name">Task ID</h6>
              <p className="comments-popup__vendor-text">
                {getValue(props, `vendorInfo.task_id`, "")}
              </p>
            </div>
            <div className="comments-popup__vendor-details">
              <h6 className="comments-popup__vendor-name">Legislation</h6>
              <p className="comments-popup__vendor-text">
                {getValue(
                  props,
                  `vendorInfo.checkpoint.legislation.legislation_name`,
                  ""
                )}
              </p>
            </div>
          </div>
          <ModalBody className="p-0 mt-3">
            {props.edit && (
              <>
                <p>Predefined Comments :</p>
                <div className="d-flex align-items-start w-100 mb-3 gap pt-3">
                  <div className="grid mb-1">
                    <div className="input-grid-item">
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Select Type"
                        options={commentsTitleList}
                        value={commentsTitleList.filter(
                          (item: any) =>
                            getValue(item, `value`, "") === selectedCommentLabel
                        )}
                        onChange={(e: any) =>
                          handleChangeComments(
                            "label",
                            getValue(e, `value`, "")
                          )
                        }
                        isClear
                      />
                    </div>
                    <div className="input-grid-item">
                      <InputField
                        inputType="INPUT_REACT_SELECT_MODAL"
                        placeholder="Select Value"
                        options={getValue(
                          commentsValueList,
                          `[${selectedCommentLabel}]`,
                          []
                        )}
                        value={getValue(
                          commentsValueList,
                          `[${selectedCommentLabel}]`,
                          []
                        ).filter(
                          (item: any) =>
                            getValue(item, `value`, "") === selectedCommentValue
                        )}
                        onChange={(e: any) =>
                          handleChangeComments(
                            "value",
                            getValue(e, `value`, "")
                          )
                        }
                        isClear
                      />
                    </div>
                  </div>
                </div>

                <textarea
                  placeholder={"Add a comment"}
                  value={comments}
                  onChange={(e) => setComments(sanitizeInput(e.target.value))}
                  className="comments-popup__form-control form-control mx-0 mt-3"
                  // rows={5}
                />
              </>
            )}
            <div className="d-flex justify-content-end">
              {isLoading ? (
                <button className="ascent-button ascent-button--header-buttons ascent-button--secondary mt-2">
                  Please wait...
                </button>
              ) : (
                <button
                  className="ascent-button ascent-button--header-buttons ascent-button--secondary mt-2"
                  onClick={handleSubmit}
                  disabled={
                    !comments ||
                    !getValue(props, `permissions`, []).includes("update")
                  }
                >
                  {editId ? "Update" : "Submit"}
                </button>
              )}
            </div>
            <div>
              {loading ? (
                <p className="text-center mt-2">Please wait...</p>
              ) : getValue(allComments, `length`, 0) > 0 ? (
                allComments.map((item: object) => {
                  return (
                    <div className="comments-popup-wrapper__comments">
                      <div>
                        <div className="d-flex align-items-start mb-3">
                          <div className="py-1">
                            <div className="vendorInfo-wrapper d-flex">
                              <p className="vendorInfo-wrapper__text">
                                {getValue(item, `is_system`, "")
                                  ? "S"
                                  : getValue(item, `created_by.first_name`, "")
                                      .charAt(0)
                                      .toUpperCase()}
                                {getValue(item, `created_by.last_name`, "")
                                  .charAt(0)
                                  .toUpperCase()}
                              </p>
                            </div>
                          </div>
                          <div className="mx-3">
                            <div className="d-flex align-items-center">
                              <div>
                                <h3 className="comments-popup-wrapper__comments-title vendorInfo-wrapper__comments-title">
                                  {getValue(item, `is_system`, "") ? (
                                    "System"
                                  ) : (
                                    <>
                                      {getValue(
                                        item,
                                        `created_by.first_name`,
                                        ""
                                      )}{" "}
                                      {getValue(
                                        item,
                                        `created_by.last_name`,
                                        ""
                                      )}
                                    </>
                                  )}
                                </h3>
                              </div>
                              <div className="mx-3">
                                {userId ===
                                  getValue(item, `created_by.id`, "") &&
                                  getValue(props, `permissions`, []).includes(
                                    "update"
                                  ) &&
                                  !getValue(item, `is_system`, false) && (
                                    <>
                                      <ul className="d-flex align-items-center">
                                        <li className="comments-popup-wrapper__comments-list-item">
                                          <a
                                            className="cursor-pointer"
                                            onClick={() => handleEdit(item)}
                                          >
                                            Edit
                                          </a>
                                        </li>
                                        <li className="comments-popup-wrapper__comments-list-item">
                                          <a
                                            className="cursor-pointer"
                                            onClick={() =>
                                              handleDeleteFun(
                                                getValue(item, `id`, ""),
                                                getValue(item, `comments`, "")
                                              )
                                            }
                                          >
                                            Delete
                                          </a>
                                        </li>
                                      </ul>
                                    </>
                                  )}
                              </div>
                            </div>
                            <p className="comments-popup-wrapper__comments-text mb-2">
                              Posted on{" "}
                              {moment(getValue(item, `created_at`, "")).format(
                                "DD-MMM-YYYY, hh:mm a"
                              )}
                              {"  "}
                            </p>
                            <p className="comments-popup-wrapper__comments-text">
                              {getValue(item, `comments`, "")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-center mt-2">No Data Found</p>
              )}
            </div>
          </ModalBody>
        </div>
      </Modal>

      <DeleteModal
        isOpen={isDelete}
        handleModal={handleDelete}
        handleSubmit={handleDeleteFunction}
        deleteValue={deleteValue}
      />
    </div>
  );
};

export default CommentsModal;
